import React from "react";
import { Typography, Button, Box } from "@mui/material";
import { useState, useEffect } from "react";
import AddLecs from "./icos-components/addLecs";
import VerifiedTable from "./icos-components/verifiedTable";
import ExistingTable from "./icos-components/existingTable";
import API from "../../api";

const Icos = () => {
    const [verifiedLecs, setVerifiedLecs] = useState([])
    const [existingLecs, setExistingLecs] = useState([])
    const [icos, setIcos] = useState('');

    useEffect(() => {
        API.getResType().then(response => {
            setIcos(response.data.type)
        })
    }, [])

    useEffect(() => {
        API.getIcosLecs().then(response => {
            let verifiedArray = [];
            let existingArray = [];

            response.data.forEach(item => {
                var tableitem = {
                    id: item.matricola,
                    ...item
                };
                tableitem.LastState = 'Existing';
                existingArray.push(tableitem);
                if (item.isActive === 0){
                    verifiedArray.push(tableitem);
                }
            });

            setVerifiedLecs(verifiedArray);
            setExistingLecs(existingArray); // Aggiorna lo stato all'interno della promise
        }).catch(error => {
            console.error('[Icos] error:', error);
        });
    }, []);


    return (
        (icos === 'producer' ?
            <Box m="20px">
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography sx={{ fontSize: 45, fontWeight: 600 }}>Produce a new LECS</Typography>
                    <Button onClick={() => { window.location.reload() }} variant="contained" sx={{
                        backgroundColor: "#2d2d2d !important",
                        fontWeight: 900,
                        "&:hover": {
                            backgroundColor: "#eaeaea !important",
                            color: "#131C2D",
                        },
                    }}>REFRESH PAGE</Button>
                </Box>

                <Box
                    display="grid"
                    gridTemplateColumns="repeat(12, 1fr)"
                    gridAutoRows="100px"
                    gap="20px"
                >
                    <Box
                        gridColumn="span 6"
                        gridRow="span 5"
                        backgroundColor={"#1e1e1e"}
                        border={"solid 3px, #449095"}
                        display="flex"
                        borderRadius='10px'
                        flexDirection='column'
                        p={2}
                        gap={2}
                    >
                        <Typography sx={{ fontSize: 25, fontWeight: 900 }}>Existing Lecs</Typography>
                        <ExistingTable data={existingLecs} />
                    </Box>
                    <Box
                        gridColumn="span 6"
                        gridRow="span 2"
                        backgroundColor={"#1e1e1e"}
                        border={"solid 3px, #449095"}

                        display="flex"
                        justifyContent="center"
                        alignItems='center'
                        borderRadius='10px'
                        flexDirection='column'
                        p={2}
                        gap={2}
                    >
                        <AddLecs />
                    </Box>

                    <Box
                        gridColumn="span 6"
                        gridRow="span 3"
                        backgroundColor={"#1e1e1e"}
                        border={"solid 3px, #449095"}

                        display="flex"
                        borderRadius='10px'
                        p={2}
                        gap={2}
                        flexDirection='column'
                    >
                        <Typography sx={{ fontSize: 25, fontWeight: 900 }}>Lecs To Activate</Typography>
                        <VerifiedTable data={verifiedLecs} />
                    </Box>

                </Box>
            </Box> : <Typography>Not authorized</Typography>
        )
    );
}

export default Icos